export default __webpack_public_path__ + "static/wt_01-2c50c1a967c48a65d7018177f380857c.png";